import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Axios from '@/shared/api/axios';
import { clearSession } from '@/shared/store/slices/userSlice';

/**
 * 登出：呼叫 /user/logout，成功時清空登入狀態並導回首頁。
 * 回傳 status_code；非成功碼與例外由呼叫端依標準寫法交給 StatusModal。
 */
export function useSignout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return async () => {
    const res = await Axios.get('/user/logout');
    const statusCode = res.data.status_code;
    if (statusCode === 'SYSTEM_1000') {
      dispatch(clearSession());
      // 搜尋紀錄存在 localStorage、不跟帳號綁定，登出時一併移除，避免留給下一個使用同一台裝置的人
      localStorage.removeItem('searchHistory');
      navigate('/');
    }
    return statusCode;
  };
}

